import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../apollo-client';
import {appHistory} from '../../history';
import {store} from '../../store';

import {TerritoriesBanner} from './territories-banner';

const TERRITORIES_BANNER_REACT_MOUNT_ID = 'territories-banner-react-mount';

export const mountTerritoriesBanner = () => {
    const territoriesBannerContainer = document.getElementById(TERRITORIES_BANNER_REACT_MOUNT_ID);

    if (territoriesBannerContainer) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <TerritoriesBanner />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            territoriesBannerContainer
        );
    }
};
